
export const API_ENDPOINTS = {
  
  //////////////////////////////////////USER URLS /////////////////////////////////////
  GET_USER_LIST:"/api/Users/getUserList",
  GET_USER_NAME:"/api/Users/getUserName",
//////////////////////////////////////PROJECT URLS /////////////////////////////////////

GET_PROJECTS_NAME: "/api/Projects/getProjects",
GET_BUG_LIST:"/api/Bugs/GetBugReport",
//////////////////////////////////////TASK URLS /////////////////////////////////////
GET_TASKS_REPORT: "/api/Tasks/GetTaskReport",
  ADD_TASK: "/api/Tasks/AddTask",
  
  UPDATE_TASK:"/api/Tasks/updateTask",
  GET_TASKS_BY_USERID: "/GetTaskListById",
  GET_TASKS_BY_PROJECTID: "/GetTaskListById",
  GET_TASKS_BYID: "/GetTask_Id/",
GET_TASK_NAME:"/api/Tasks/getTasks",

  ///////////////////////////////////// status /////////////////////////////////////
  GET_STATUS: "/status",
  GET_PRIORIIY:"/priority",
  GET_ROLE:"/ROLE",

GET_BUG_ONLOAD:"/getBugsOnload",
GET_BUG_LIST_PAGE:"/getbuglisting",
GET_BUG_LIST_BYID:"/GetBugListById",
GET_BUG_BYID:"/GetBug_Id",
//Update_Bug:"/api/Bugs/UpdateBug",
Update_Bug:"/api/Bugs/UpdateUserBug",
GET_BUG_HISTORY:"/BugHistory",
 POST_BUG:"/api/Bugs/addBug"
};